import { useSyncExternalStore } from 'react'
import { auth, subscribeAuth } from './auth'
import type { User } from '@/api/types'

/**
 * Napojeni komponent na stav prihlaseni. useSyncExternalStore je tu presne
 * na tohle: store zije mimo React (potrebuje ho router uz v beforeLoad),
 * ale komponenty se maji prekreslit, kdyz se zmeni.
 */
export function useAuth(): { user: User | null; isAuthenticated: boolean } {
  return useSyncExternalStore(subscribeAuth, getSnapshot, getSnapshot)
}

let snapshot = { user: auth.user, isAuthenticated: auth.isAuthenticated }

function getSnapshot() {
  // Novy objekt jen kdyz se opravdu neco zmenilo — jinak by useSyncExternalStore
  // videl porad jinou referenci a prekresloval donekonecna.
  if (snapshot.user !== auth.user || snapshot.isAuthenticated !== auth.isAuthenticated) {
    snapshot = { user: auth.user, isAuthenticated: auth.isAuthenticated }
  }
  return snapshot
}
